var chunkToChildrenMap = {
	"2583": [
		1713,
		5122,
		6630
	],
	"4508": [
		6394,
		3089,
		625
	],
	"7825": [
		6465
	],
	"9307": [
		6630
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));